<template>
  <div class="page_view">
    <div class="page_title backdrop">Recent Work History</div>

    <div class="panel backdrop">
      <div class="panel_header">
        <div class="panel_title">Present</div>
      </div>
      <div class="panel_body">
        <div class="job_content kloudfuse">
          <div class="icon"></div>
          <div class="desc">
            <div class="title">KloudFuse</div>
            <div class="duties">
              <p>Building a UI for this stealth-mode startup attempting to build
                 an incident remediation platform.</p>
            </div>
          </div>
        </div>
      </div>
      <div class="panel_body">
        <div class="job_content anwansi">
          <div class="icon"></div>
          <div class="desc">
            <div class="title">Consulting Services</div>
            <div class="duties">
              <p>Currently offering consulting services for general software
                 development, web design, web application development, and mobile
                 apps. <a target="_blank" href="https://anwansi.com">Visit
                 website</a> for contact info.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="panel backdrop">
      <div class="panel_header">
        <div class="panel_title">2020</div>
      </div>
      <div class="panel_body">
        <div class="job_content thatsaread">
          <div class="icon"></div>
          <div class="desc">
            <div class="title"><a target="_blank" href="https://thatsaread.com">That's A Read</a> beta</div>
            <div class="duties">
              <p><a target="_blank" href="https://thatsaread.com">That's A Read</a>
              is an independent project (through Anwansi) that allows users to
              manage book clubs.</p>
            </div>
          </div>
        </div>
      </div>
      <div class="panel_body">
        <div class="job_content netspyglass">
          <div class="icon"></div>
          <div class="desc">
            <div class="title">Consulting for <a target="_blank" href="https://netspyglass.com">NetSpyGlass</a></div>
            <div class="duties">
              <p>Rebuilt <a target="_blank" href="https://netspyglass.com">NetSpyGlass's</a> corporate website with go-to-market workflows.</p>
              <p>Provided professional services on behalf of NetSpyGlass to its customers.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="panel backdrop">
      <div class="panel_header">
        <div class="panel_title">2019</div>
      </div>
      <div class="panel_body">
        <div class="job_content aviatrix">
          <div class="icon"></div>
          <div class="desc">
            <div class="title">Consulting for <a target="_blank" href="https://aviatrix.com">Aviatrix</a></div>
            <div class="duties">
              <p>Built a web-based, multi-cloud visibility tool for solutions
                 team to deliver to customers.</p>
            </div>
          </div>
        </div>
      </div>
      <div class="panel_body">
        <div class="job_content veriflow">
          <div class="icon"></div>
          <div class="desc">
            <div class="title">Consulting for Veriflow</div>
            <div class="duties">
              <p>Tasked with redesigning product UI using modern tooling, ES6,
                 and the Vue.js framework.</p>
              <p>(Veriflow was acquired by VMware in August 2019.)</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="panel backdrop">
      <div class="panel_header">
        <div class="panel_title">2013&ndash;2018</div>
      </div>
      <div class="panel_body">
        <div class="job_content bsn">
          <div class="icon"></div>
          <div class="desc">
            <div class="duties">
              <p>From March 2013 until September 2018, I worked as the GUI
                 Architect at <a href="https://www.bigswitch.com">Big Switch
                 Networks, Inc.</a>, building web-based user interfaces from
                 scratch for three core products.  For the last twelve months, I
                 managed a talented team of three to grow capacity and accelerate
                 feature development.</p>
              <p>See some presentations of my work &hellip;</p>
              <ul class="highlight">
                <li><a target="_blank" href="https://techfieldday.com/video/big-switch-cloud-first-networking-demo/">Networking Field Day 2018</a></li>
                <li>
                  Webinar Series
                  <ul>
                    <li><a target="_blank" href="https://www.youtube.com/watch?v=VYuWJy7cIg4">Part 3</a></li>
                    <li><a target="_blank" href="https://www.youtube.com/watch?v=fbQt20Nb9Oc">Part 2</a></li>
                    <li><a target="_blank" href="https://www.youtube.com/watch?v=V-UTtPJRBqk">Part 1</a></li>
                  </ul>
                </li>
                <li><a target="_blank" href="https://www.google.com/search?q=big+switch+gui">Various demos and presentations</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="panel backdrop">
      <div class="panel_header">
        <div class="panel_title">2009&ndash;2013</div>
      </div>
      <div class="panel_body">
        <div class="job_content nicira">
          <div class="icon"></div>
          <div class="desc">
            <div class="duties">
              <p>From September 2009 until March 2013, I was UI Engineer at the
                 startup Nicira, which was acquired by VMware in July 2012. I
                 worked with a small team to build the UI for Nicira's Network
                 Virtualization Platform (NVP), which would become VMware's NSX
                 solution.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="panel backdrop">
      <div class="panel_body">
        <div class="notice">Complete resumé available
            <router-link :to="{ name : 'resume' }">here</router-link>
            (access code required).</div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
    name : "Career"
};

</script>

<style scoped>

.job_content {
    width:100%;
    display:flex;
    flex-wrap:nowrap;
    justify-content:flex-start;
    align-items:flex-start;
    position:relative;
    margin:0px;
}

.job_content .icon {
    flex-shrink:0;
    width:160px;
    background-repeat:no-repeat;
    background-size:contain;
    background-position:center top;
}

.job_content .desc {
    padding:0px 20px;
}

.job_content .title {
    font-size:24px;
    color:var(--main-orange);
    padding-bottom:0.2em;
    margin-bottom:0.2em;
    border-bottom:1px solid rgba(var(--main-orange-rgb), 0.35);
}

.job_content .duties p {
    font-size:18px;
    margin-top:0px;
    color:var(--light-orange);
}

.job_content .duties ul {
    font-size:16px;
    margin-top:0px;
}

.job_content .duties a {
    color:var(--soft-orange);
}

.job_content.anwansi .icon {
    height:95px;
    background-image:url('/images/anwansi-icon.png');
}

.job_content.kloudfuse .icon {
    height:95px;
    background-image:url('/images/kloudfuse-icon.png');
}

.job_content.thatsaread .icon {
    height:77px;
    background-image:url('../assets/img/thatsaread-logo.png');
}

.job_content.bsn .icon {
    height:184px;
    background-image:url('/images/bsn-icon.png');
}

.job_content.nicira .icon {
    height:125px;
    background-image:url('/images/nicira-icon.png');
}

.job_content.veriflow .icon {
    height:154px;
    background-image:url('/images/veriflow-icon.png');
}

.job_content.aviatrix .icon {
    height:154px;
    background-image:url('/images/aviatrix-icon.png');
}

.job_content.netspyglass .icon {
    height:154px;
    background-image:url('/images/netspyglass-icon.png');
}

.notice {
    font-size:18px;
    padding:20px 10px;
}

@media only screen and (max-width:500px) {
    .job_content {
        flex-direction:column;
        align-items:center;
    }

    .job_content .desc {
        padding:20px 0px;
    }

    .job_content .title {
        font-size:18px;
    }

    .job_content .duties p {
        font-size:14px;
    }

    .job_content .duties ul {
        font-size:14px;
    }
}

</style>
